import {isEmpty, isArray, isObject} from './boolean';
import {getObjectProp} from './object';

export const implode = (delimiter, arr, noEmpty = true) =>
  (noEmpty ? arr.filter(item => !isEmpty(item)) : arr).join(delimiter);

export const range = (start, end) =>
  Array.from({length: end - start}, (v, k) => k + start);

export const arrayUnique = arr => {
  if (!isArray(arr)) {
    // eslint-disable-next-line no-console
    console.error(`first argument should be an array.`);
    return false;
  }
  const iterator = (value, index, self) => self.indexOf(value) === index;
  return arr.filter(iterator);
};

/**
 *
 * @param {array} data
 * @returns {string}
 */
export const jsonEncode = data => JSON.stringify(data);

/**
 *
 * @param {string} str
 * @returns {array}
 */
export const jsonDecode = str => JSON.parse(str);

/**
 * Removes empty items from an array
 *
 * @param {array} arr
 * @param {string} prop - if array of object and want to check against specific property of object
 * @param {boolean} allowZero
 * @returns {array}
 */
export const filterEmpty = (arr, prop = undefined, allowZero = false) => {
  if (!isArray(arr)) {
    return [];
  }
  return arr.filter(item => {
    if (!!prop && isObject(item)) {
      const value = getObjectProp(item, prop);
      return !!value || (allowZero && value === 0);
    }
    return !!item || (allowZero && item === 0);
  });
};
